import { render, staticRenderFns } from "./CategoryGames.vue?vue&type=template&id=2435e606&scoped=true&"
import script from "./CategoryGames.vue?vue&type=script&lang=js&"
export * from "./CategoryGames.vue?vue&type=script&lang=js&"
import style0 from "./CategoryGames.vue?vue&type=style&index=0&id=2435e606&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2435e606",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2435e606')) {
      api.createRecord('2435e606', component.options)
    } else {
      api.reload('2435e606', component.options)
    }
    module.hot.accept("./CategoryGames.vue?vue&type=template&id=2435e606&scoped=true&", function () {
      api.rerender('2435e606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/categoryGames/CategoryGames.vue"
export default component.exports